module.exports = __webpack_public_path__ + "img/nmc.62bee51e.svg";